import React from "react";

const IndustriesContect = [
  {
    name:  "Real Estate", 
    icon:"hotel",
    details: `We have been providing accounting and custom transaction services to companies in the real estate sector for more than a decade. The sector’s specific VAT rules, public procurement tenders, and warranty and guarantee obligations require special expertise.`,
  },
  {
    name:  "Technology", 
    icon:"wifi",
    details: `Our advisors have a wealth of knowledge in auditing technology companies, providing transactional M&A services, as well as accounting and management services for start-ups.`,
  },
  {
    name:  "Retail", 
    icon:"handshake",
    details: `For trading companies, we deliver tailor-made solutions for tax and accounting issues related to stock planning and international market entry. Our accounting services help you comply with the ever-changing regulatory environment.`,
  },
  {
    name:  "Healthcare", 
    icon:"first-aid",
    details: `We offer effective solutions to pharmaceutical manufacturers, distributors, healthcare providers, and manufacturers and sellers of medical instruments and equipment.`,
  },
  {
    name:  "Legal", 
    icon:"user-graduate",
    details: `From the beginning, we have been working with public notaries, lawyers, and attorneys, assisting them with comprehensive services such as accounting, auditing, and core compliance services.`,
  },
  {
    name:  "Agriculture", 
    icon:"tractor",
    details: `Our expert team has extensive experience in the specialties of the agricultural sector. You can rely on us for accounting and auditing of agricultural costs, inventory management, and government subsidies.`,
  }
]
const Industries = () => {
  return (
    <div className="row">
      {IndustriesContect.map((val, i) => (
        <div className="col-lg-4 col-sm-6 mt-4">
        
          <div className="row">
          <div className="col-2 industries-icon  ">
            <i className={`fa fa-${val.icon}`}></i>
            </div>
            <div className="col-8">
            <h5 className="poppins-font text-uppercase row-hack industries-name">
            {val.name}
            
          </h5>
          </div>
          </div>
         
          
          <p className="open-sans-font justify no-margin-bottom">{val.details}</p>
        
    </div>
      ))}
    </div>
  );
  
};

export default Industries;